/** @jsx jsx */
import { H2, P } from "@cd2/text"
import { titleize } from "@cd2/tools"
import { css, jsx } from "@emotion/core"
import { brandColors, themeColors } from "../../Components/EOSThemeProvider"
import { RmaStatus, rmaStatusMessages } from "./RmasIndexPage"

export const rmaStatusColorMap: Record<RmaStatus, { bg: string; text?: string }> = {
  pending: { bg: themeColors.lightOrange },
  closed: { bg: themeColors.grey, text: "white" },
  raised: { bg: themeColors.orange, text: "white" },
  awaiting_goods_receipt: { bg: themeColors.orange, text: "white" },
  awaiting_transfer: { bg: brandColors.archived },
  rejected: { bg: themeColors.red, text: "white" },
  accepted_for_credit: { bg: themeColors.green, text: "white" },
  awaiting_processing: { bg: themeColors.green, text: "white" },
  awaiting_repair: { bg: themeColors.green, text: "white" },
}
export function RmaStatusCard({ status, message }: { status: RmaStatus; message?: string }) {
  const color = rmaStatusColorMap[status]
  return (
    <div>
      <div
        css={css`
          padding: 8px 16px;
          background-color: ${color?.bg};
          border-radius: 6px;
          width: 280px;
        `}
      >
        <H2 color={color?.text}>{titleize(status)}</H2>
        {message ? (
          <P
            css={css`
              white-space: pre-wrap;
            `}
            blockSpacing={0}
            color={color.text}
          >
            {message}
          </P>
        ) : (
          <P color={color?.text} blockSpacing={0}>
            {rmaStatusMessages[status]}
          </P>
        )}
      </div>
    </div>
  )
}
